import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { CardPreview } from './CardPreview/CardPreview';
import { useTeachingBlockStore } from './Contexts/TeachingBlockContext';
import { GridHeader } from './GridHeader/GridHeader';
import { GridRows } from './GridRows/GridRows';
import { CardDurationModal } from './Modals/CardDurationModal/CardDurationModal';
import { CardRoomsModal } from './Modals/CardRoomsModal/CardRoomsModal';
import { ConflictModal } from './Modals/ConflictModal/ConflictModal';
import { TimeConflictModal } from './Modals/TimeConflictModal/TimeConflictModal';
import styles from './TeachingBlockGrid.module.scss';
import { isCoexistableTeachingBlockCard } from './types';

export const TeachingBlockGrid = observer(() => {
  const store = useTeachingBlockStore();

  // Ist ein Wahlfach aufgenommen, soll es auf bereits belegten Tagen gestapelt werden
  // können. Dafür müssen die dort liegenden Wahlfach-Karten die Maus durchlassen, damit
  // der Klick zur Tageszelle (.droppable) durchfällt – sonst fängt die obenliegende Karte
  // ihn ab und die CardPreview verwirft den Pick. Der Schalter sitzt am Root (der ohnehin
  // auf `pickedCard` hört); ein `pickedCard`-Abo je Karte würde beim Aufnehmen das ganze
  // Grid neu rendern.
  const stackingPick = !!store.pickedCard && isCoexistableTeachingBlockCard(store.pickedCard.card);

  // Ist irgendeine Karte aufgenommen, muss die Fahrt-Karte den Klick zur Tageszelle
  // durchlassen — sonst fängt sie ihn ab, es fehlt die `droppable`-Klasse und CardPreview
  // verwirft den Pick (siehe CardPreview.tsx). Der Schalter sitzt aus demselben Grund wie bei
  // `stacking-pick` am Root: ein `pickedCard`-Abo je Fahrt-Karte würde beim Aufnehmen das
  // ganze Grid neu rendern.
  const hasPick = !!store.pickedCard;

  return (
    <div
      className={classNames(styles['teaching-block-grid'], {
        [styles['stacking-pick']]: stackingPick,
        [styles['has-pick']]: hasPick,
        [styles['is-fullscreen']]: store.isFullscreen,
      })}
    >
      <GridHeader />
      <GridRows />
      {store.pickedCard && (
        <CardPreview pickedCard={store.pickedCard} preventEscape={store.timeConflictModal.isOpen ?? false} />
      )}
      <ConflictModal />
      <TimeConflictModal />
      <CardDurationModal />
      <CardRoomsModal />
    </div>
  );
});
